'use client';

import { Button, Grid, Typography } from '@mui/material';

export default function NotFound() {
	const goToProjects = () => {
		const { origin } = window.location;
		window.location.href = `${origin}/projects`;
	};

	return (
		<Grid
			container
			sx={{
				direction: 'column',
				height: '100vh',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Grid sx={{ alignItems: 'center', mb: 4 }}>
				<Typography variant='h1' sx={{ fontSize: 48, mb: 2 }}>
					404 | Page not found
				</Typography>
			</Grid>
			<Grid sx={{ alignItems: 'center' }}>
				<Button variant='contained' onClick={goToProjects}>
					Go to Projects
				</Button>
			</Grid>
		</Grid>
	);
}
